module.exports = {"540524100":"琼结镇","540524200":"拉玉乡","540524201":"下水乡","540524202":"加麻乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540524.json
// module id = 2531
// module chunks = 0